module.exports = __webpack_public_path__ + "img/MEDIA093.ee2cc432.jpg";